import Table, { type Column as TableColumn } from 'further-ui/components/Table';
import { CommitmentData } from '../../types';
import { Column } from 'further-ui/components/Layout';
import { numberToCurrencyString } from 'further-ui/utils';
import { IncomeAndExpensesLabels } from 'further-ui/labels';

type Props = Pick<CommitmentData, 'currencySettings' | 'incomeAndExpenses'>;

const IncomeAndExpenses: React.FC<Props> = ({
  currencySettings,
  incomeAndExpenses,
}) => {
  const { currencyLcy } = currencySettings;

  const columns: Array<TableColumn<(typeof incomeAndExpenses)[number]>> = [
    {
      label: 'Action',
      key: 'action',
      render: ({ action }) => action,
    },
    {
      label: 'Date',
      key: 'date',
      render: ({ date }) => date.toReadable(),
    },
    {
      label: 'Category',
      key: 'category',
      render: ({ category }) => IncomeAndExpensesLabels[category],
    },
    {
      label: 'Income/(Expense)',
      key: 'valueLcy',
      render: ({ valueLcy }) =>
        numberToCurrencyString(valueLcy, {
          currency: currencyLcy,
        }),
    },
  ];

  return (
    <Column>
      <Table
        emptyMessage="No entries"
        columns={columns}
        rows={incomeAndExpenses}
      />
    </Column>
  );
};

export default IncomeAndExpenses;
